import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../../_models/garantias-idoneas';
import {GarantiasIdoneasDestino} from '../../../_models/garantias-idoneas-destino';
import {ListaItem} from '../../../_models/lista-item';
import {GarantiaIdoneasDestinosService} from '../../../_services/garantia-idoneas-destinos.service';
import {ListaService} from '../../../_services/lista.service';
import {NavService} from '../../../_services/_nav.service';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {SegmentoNivelEndeudamiento} from '../../../_models/segmento-nivel-endeudamiento';
import {GarantiasIdoneasMunicipio} from '../../../_models/garantias-idoneas-municipio';
import {DivisionPolitica} from '../../../_models/division-politica';
import {GarantiaIdoneasMunicipioService} from '../../../_services/garantia-idoneas-municipio.service';
import {DivisionPoliticaService} from '../../../_services/division-politica.service';

@Component( {
  selector: 'app-garantia-idoneas-municipios',
  templateUrl: 'garantia-idoneas-municipios.component.html'
} )

export class GarantiaIdoneasMunicipiosComponent implements OnInit {

  formulario: FormGroup;
  /** items */
  @Input() garantia: GarantiasIdoneas;
  destino: GarantiasIdoneasMunicipio;

  /** Listas */
  listGarantiasIdoneasMunicipio: GarantiasIdoneasMunicipio[] = [];
  lisDepartamentos: SelectItem[] = [];
  lisMunicipios: SelectItem[] = [];
  listaDepartamentos: DivisionPolitica[] = [];
  listaMunicipios: DivisionPolitica[] = [];


  columnas: any[] = [];
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  indicadorPlan = false;
  @ViewChild('dt') tabla: Table;

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private garantiasIdoneasMunicipio: GarantiaIdoneasMunicipioService,
    private confirmacionServicio: ConfirmationService,
    private divisionPoliticaServicio: DivisionPoliticaService
  ) {
  }

  ngOnInit() {

    if ( this.garantia && (this.garantia.idGarantiaIdonea !== '' && this.garantia.idGarantiaIdonea !== null && this.garantia.idGarantiaIdonea !== undefined) ) {
      /** Se carga garantias Servicios */
      forkJoin(
        this.garantiasIdoneasMunicipio.listadoPorMunicipios( this.garantia.idGarantiaIdonea ),
        this.divisionPoliticaServicio.obtenerConHijos('0')
      ).subscribe( ( [ garantiaDestinos, paises ] ) => {
        this.listGarantiasIdoneasMunicipio = garantiaDestinos;
        this.cambiarDepartamento(paises.find(pa => pa.codigoDivisionPolitica === "PCOL").idDivisionPolitica);
        this.cargarInformacionInicial();
      } );
    }
  }

  get getGarantiasIdoneasDestino() {
    return this.listGarantiasIdoneasMunicipio.filter( s => s.indicadorHabilitado );
    this.carTabla = false;
  }


  cargarInformacionInicial() {

    this.carTabla = false;
    this.columnas = [
      { field: 'departamento', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_DEPARTAMENTO' ), sort: true },
      { field: 'municipio', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_MUNICIPIO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idGarantiaIdonea: [ this.destino ? this.destino.idGarantiaIdonea : null ],
      idDepartamento: [ null, [ Validators.required ] ],
      idMunicipio: [ [] , [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
    this.lisMunicipios = [];
    this.indicadorPlan = false;
    this.carInformacionInicial = false;
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const forData = this.formulario.value;

      const tempGarantiasMunicipio: GarantiasIdoneasMunicipio[] = [];
      forData.idMunicipio.forEach(municipio => {
        let temp  = {} as GarantiasIdoneasMunicipio;
        temp.idGarantiaIdonea = this.garantia.idGarantiaIdonea;
        temp.idMunicipio = municipio;
        temp.indicadorHabilitado = true;
        const a = this.listGarantiasIdoneasMunicipio.
        find( sp => sp.idMunicipio === temp.idMunicipio );
        if ( a ) {
          temp.idGarantiaIdoneaMunicipio = a.idGarantiaIdoneaMunicipio;
        }
        tempGarantiasMunicipio.push(temp);
      });

      this.garantiasIdoneasMunicipio.bulk( tempGarantiasMunicipio ).subscribe( res => {
        const tempSegmentoP: GarantiasIdoneasMunicipio[] = this.listGarantiasIdoneasMunicipio;
        this.listGarantiasIdoneasMunicipio = [];
        res.map(re => {
          re.departamento = this.listaDepartamentos.
          find( p => p.idDivisionPolitica === this.f.idDepartamento.value ).descripcionDivisonPolitica;
          re.municipio = this.listaMunicipios.find(
            p => p.idDivisionPolitica === re.idMunicipio ).descripcionDivisonPolitica;
          tempSegmentoP.map( t => {
            if ( t.idGarantiaIdoneaMunicipio === re.idGarantiaIdoneaMunicipio ) {
              t.indicadorHabilitado = true;
            }
          } );
          if(!tempSegmentoP.find(di=> di.idGarantiaIdoneaMunicipio ===  re.idGarantiaIdoneaMunicipio)){
            tempSegmentoP.push(re);
          }
        });
        this.lisMunicipios = [];
        this.listGarantiasIdoneasMunicipio = tempSegmentoP;
        this.formulario.reset();
        this.submitted = false;
        this.guardando = false;
      } );
    }
  }

  disable( row: GarantiasIdoneasMunicipio ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Garantías idóneas Municipio',
      icon: 'fa fa-question-circle',
      key: 'garantia-idoneas-municipio',
      accept: () => {
        row.indicadorHabilitado = false;
        this.garantiasIdoneasMunicipio.actualizar( row ).subscribe( res => {
          const temp: GarantiasIdoneasMunicipio[] = this.listGarantiasIdoneasMunicipio;
          this.listGarantiasIdoneasMunicipio = [];
          temp.map( t => {
            if ( t.idMunicipio === row.idMunicipio ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.listGarantiasIdoneasMunicipio = temp;
          this.lisMunicipios = [];
        } );
      }
    } );
  }

  cambiarDepartamento( idPais: string ) {
    this.lisDepartamentos = [];
    this.lisMunicipios = [];

    this.divisionPoliticaServicio.obtenerConHijos(idPais ).subscribe(
      departamentos => {
        // llenado lista departamentos
        departamentos.map( ( s: DivisionPolitica ) => {
          this.lisDepartamentos.push( { label: s.descripcionDivisonPolitica, value: s.idDivisionPolitica } );
        } );
        this.listaDepartamentos = departamentos;
      }
    );
  }


  cambiarMunicipio( idDepartamento: string ) {
    this.lisMunicipios = [];

    this.divisionPoliticaServicio.obtenerConHijos(idDepartamento ).subscribe(
      municipios => {
        // llenado lista municipios
        this.listaMunicipios = municipios;
        municipios.map( ( s: DivisionPolitica ) => {
          if (! this.listGarantiasIdoneasMunicipio.find( mu => mu.idMunicipio === s.idDivisionPolitica
            && mu.indicadorHabilitado) ) {
            this.lisMunicipios.push( { label: s.descripcionDivisonPolitica, value: s.idDivisionPolitica } );
          }
        });
      }
    );
  }



  }
